import React from "react";
import { PopUps } from "../enums/Constants";
import { useEffect } from "react";

const CheckoutPopup = ({ openPopUp, closePopUp }) => {
  const RefreshPage = () => {
    closePopUp();
  };

  // Automatically close the popup after 3 seconds
  useEffect(() => {
    if (openPopUp) {
      const timer = setTimeout(() => {
        closePopUp(); // Close the popup
      }, 3000); // 3 seconds delay

      return () => clearTimeout(timer); // Cleanup the timer on unmount
    }
  }, [openPopUp, closePopUp]);

  if (openPopUp !== true) return null;

  return (
    <div
      id="ModelContainer"
      className="fixed inset-0 bg-black flex justify-center items-center bg-opacity-20 backdrop-blur-sm z-40"
    >
      <div className="relative bg-blue-400 w-5/6 xl:w-[400px] 3xl:w-[600px]  text-center mx-auto rounded-[30px] p-10 pt-14 shadow-[0_0_7px_rgba(92,92,92,0.35)] drop-shadow-[0_0_4px_rgba(178,178,178,0.2)">
        <div className="w-full xl:w-4/5 text-center mx-auto">
          <img
            src="./icons/success_create.svg"
            alt=""
            className="mx-auto xl:scale-75 3xl:scale-100"
          />
          <h2 className="font-robotoBold text-gray-800 py-5 3xl:py-7 text-center text-3xl 3xl:text-4xl">
            {PopUps.CHECK_OUT_POPUP}
          </h2>
          <button
            className="bg-blue uppercase text-2xl xl:text-base 3xl:text-2xl border border-blue hover:bg-blue-800 hover:border-blue-800 text-white font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in leading-relaxed"
            type="button"
            onClick={RefreshPage}
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPopup;
